import bodyTitle from './BodyTitle'
import caption from './Caption'
import imageHeader from './ImageHeader'
import layout from './Layout'
import logo from './Logo'
import text from './Text'
import titleHeader from './TitleHeader'
import videoHeader from './VideoHeader'
import richText from './RichText'

export const BodyTitle = bodyTitle
export const Caption = caption
export const ImageHeader = imageHeader
export const Layout = layout
export const Logo = logo
export const Text = text
export const TitleHeader = titleHeader
export const VideoHeader = videoHeader
export const RichText = richText
